import { Expose, Type } from "class-transformer";
import { LinkInvoiceToCertificationItemDto } from "@/core/features/certifications-have-invoices/link-invoice-to-certification-item.dto";

export class LinkInvoicesToCertificationDto {
  @Expose()
  certificationId: string;

  @Expose()
  @Type(() => LinkInvoiceToCertificationItemDto)
  invoices: LinkInvoiceToCertificationItemDto[];
}
